import type { TemplateField } from "@/api/researchCms.service";

export type TemplateFieldRow = {
  fieldLabel: string;
  fieldName: string;
  fieldType: string;
  publishable: boolean;
  editable: boolean;
};

export function templateFieldRows(fields: TemplateField[]): TemplateFieldRow[] {
  return fields
    .filter(field => field.fieldTab === "submission" && Boolean(field.publishable))
    .sort((a, b) => a.position - b.position)
    .map(field => ({
      fieldLabel: field.fieldLabel,
      fieldName: field.fieldName,
      fieldType: field.fieldType,
      publishable: Boolean(field.publishable),
      editable: Boolean(field.editable),
    }));
}
